






































import BaseComponent from "@/asdcom/BaseComponent";
import { Component } from "vue-property-decorator";
import util from "@/lib/util";
import {
  ClaimsTasksDto,
  IClaimsTasksDto,
  IClaimTaskDto,
  ClaimUpdateTaskCategory
} from "@/asdcom/apiproxy/apiproxy.dto";
import { IHeader } from "@/store/models/staff/IHeader";
import bus from "@/components/vcponlineok/bus/bus.js";

@Component({})
export default class ClaimTasks extends BaseComponent {
  loading: boolean = false;
  updateTypes = util.abp.constant.claimStatus.values;

  headers: IHeader[] = [
    { text: "Claim Number", value: "claimNumber", align: "center" },
    { text: "Task Type", value: this.L("claimUpdateTaskCategory"), align: "center"},
    { text: "Received", value: "receivedDate", align: "center" },
    { text: "Assigned County", value: "claimAssignedCounty", align: "center" },
    {
      text: "Victim, Claimant, Crime Date",
      value: "claimSummary",
      sortable: false,
      width: 450,
      // align: "center"
    }
  ];
  data: IClaimTaskDto[] = [];

  async created() {
    this.retrieveCountsAndTasks();
  }

  async retrieveCountsAndTasks() {
    this.$appsvs.vcpOnlineOkStaff.refreshTaskCounts();
    this.$appsvs.vcpOnlineOkStaff
      .retrieveClaimsTasks()
      .then((res: IClaimsTasksDto) => {
        if (!!res.claimTasks) {
          this.data = res.claimTasks;
        }
      });
  }

  mounted() {
    bus.$on('refreshList', () => {
      this.retrieveCountsAndTasks();
    })
  }

  beforeDestroy() {
    bus.$off('refreshList');
  }

  onTaskTableRowClick(item: IClaimTaskDto) {
    if (!item.claimUpdateTaskCategory || !item.claimNumber) {
      return;
    }
    // const itemType = item.claimUpdateTaskCategory;
    switch (item.claimUpdateTaskCategory) {
      case ClaimUpdateTaskCategory.ClaimUpdateRequest:
        this.$router.push({
          name: "UpdateRequests",
          params: { claimNumber: item.claimNumber }
        });
        break;
      case ClaimUpdateTaskCategory.NewClaim:
        this.$router.push({
          name: "ClaimSummary",
          params: { claimNumber: item.claimNumber }
        });
        break;
      case ClaimUpdateTaskCategory.ApplicantResponse:
        // const filter = "applicant-response";
        this.$router.push({
          name: "Messages",
          params: { claimNumber: item.claimNumber }
        });
        break;
      default:
        break;
    }
  }
}
